import React from 'react';
import ChannelDistributionDashboardPanel from './ChannelDistributionDashboardPanel';
import ConnectionsDashboardPanel from './ConnectionsDashboardPanel';
import EngagementsDashboardPanel from './EngagementsDashboardPanel';
import McpConfigDashboardPanel from './McpConfigDashboardPanel';
import PlanningDashboardRow from './PlanningDashboardRow';

const EngineView: React.FC = () => {
  return (
    <div className="space-y-4">
      <ConnectionsDashboardPanel />
      <EngagementsDashboardPanel />
      <PlanningDashboardRow />
      <ChannelDistributionDashboardPanel />
      <McpConfigDashboardPanel />
    </div>
  );
};

export default EngineView;
